import React from 'react';
import Zoom from 'react-medium-image-zoom';

const title = "Balance Sheet";
const description = `a snapshot of a business's financial position at a specific point in time. It is structured to show what the business owns (Assets), how it is financed through what it owes to others (Liabilities), and what the owners have invested (Equity). This report is built on the fundamental accounting equation that Assets must always equal the sum of Liabilities and Equity.`;

const images = [
    '/images/reports/business-overview/balance-sheet/balance-sheet.png', // 0
];


const BalanceSheet: React.FC = () => {

    return (
        <div className="max-w-4xl lg:max-w-5xl min-h-screen bg-gray-50 flex gap-2">
            <div className="overflow-auto mx-auto flex-2">

                <div className="mb-6">
                    <h1 className="text-3xl font-bold pt-4 text-gray-900">
                        {title}
                    </h1>
                    <p className="text-gray-600 mt-4">
                        {description}
                    </p>
                    <div className="bg-white rounded-lg shadow-sm border border-gray-200 p-6 my-6">
                        <Zoom>
                            <img
                                src={images[0]}
                                alt={title}
                                className="w-full max-w-4xl h-auto border border-gray-200 rounded-lg shadow-sm mx-auto"/>
                        </Zoom>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default BalanceSheet;
